import { API_URL } from "../../utils/globals";
import axios, { AxiosInstance } from "axios";
import secureLocalStorage from "react-secure-storage";
import { GetAllRefundsResponse } from "@services/models/Refund/GetAllRefundsModel";
import {
  GetRefundDetailsRequest,
  GetRefundDetailsResponse,
} from "@services/models/Refund/GetRefundDetails";
import {
  SubmitRefundRequest,
  SubmitRefundResponse,
} from "@services/models/Refund/SubmitRefundModel";

class RefundsApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
    this.api.interceptors.request.use(
      (config) => {
        const token = secureLocalStorage.getItem("jwt");

        config.headers.Authorization = `Bearer ${token}`;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    this.api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log("Interceptor error handling:", error.response);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          console.log("Detected 401 error, clearing JWT and reloading.");
          secureLocalStorage.removeItem("jwt");
          sessionStorage.clear();
          window.location.reload();
        }
        return Promise.reject(error);
      }
    );
  }

  public async getAllRefunds(): Promise<GetAllRefundsResponse> {
    try {
      const response = await this.api.get("/cashierPanel/getAllRefunds");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getRefundDetails(
    data: GetRefundDetailsRequest
  ): Promise<GetRefundDetailsResponse> {
    try {
      const response = await this.api.get("/cashierPanel/getRefundDetails", {
        params: {
          refundId: data.refundId,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async submitDetails(
    data: SubmitRefundRequest
  ): Promise<SubmitRefundResponse> {
    try {
      const formData = new FormData();
      formData.append("cashierNotes", data.cashierNotes);
      formData.append("refundId", data.refundId);
      formData.append("image", data.file);

      const response = await this.api.post<SubmitRefundResponse>(
        "/cashierPanel/submitDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const refundsServices = new RefundsApiService();
